"use client";
import { useCallback, useState } from "react";

export type Disclosure = ReturnType<typeof useDisclosure>;

export const useDisclosure = (isOpenDefault = false) => {
  const [isOpen, setOpen] = useState(isOpenDefault);

  const onOpen = useCallback(() => setOpen(true), []);
  const onClose = useCallback(() => setOpen(false), []);
  const toggle = useCallback(() => {
    return setOpen(!isOpen);
  }, [isOpen]);

  return { isOpen, setOpen, onOpen, onClose, toggle };
};
